import { SortDescriptor, orderBy } from "@progress/kendo-data-query";
import { Chip } from "@progress/kendo-react-buttons";
import { Grid, GridColumn, GridCustomCellProps, GridSortChangeEvent } from "@progress/kendo-react-grid";
import { useState } from "react";
import { dateToBdFormat } from "../../commons/helpers/Dates";
import { Agence } from "../../models/Agence";
import { Magasin } from "../../models/Magasin";
import { useGetEmployesQuery } from "../../redux/api/cache";

interface EmployeesListProps {
    date: Date
    magasin: Magasin;
    agence: Agence;
}

export default function EmployeesList(props: EmployeesListProps) {
    const { data: employes = [] } = useGetEmployesQuery({ agence: props.agence.agence_cd, mag_num: props.magasin.mag_num, date: dateToBdFormat(props.date) }, { skip: props.magasin.mag_num === -1 || !props.agence.agence_cd, refetchOnMountOrArgChange: true });
    const [sort, setSort] = useState<SortDescriptor[]>([
        {
            field: "statut",
            dir: "asc",
        }
    ]);

    const CustomCell = (props: GridCustomCellProps) => {
        const { dataItem } = props;
        const field = props.field || "";
        const cellData = dataItem[field];
        return (
            <td>
                <Chip
                    text={String(cellData)}
                    value="chip"
                    disabled={true}
                    style={{ backgroundColor: cellData === "Disponible" ? '#48f777' : '#e4e7eb', opacity: '1' }}
                />

            </td>
        );
    };

    const handleSortChange = (event: GridSortChangeEvent) => {
        setSort(event.sort);
    };

    const processData = () => {
        const employesDisponibles = orderBy(employes, sort).filter(e => e.statut !== "Assigné");
        const currentSort = sort[0];
        if (currentSort.field !== "statut")
            return employesDisponibles
        else
            return employesDisponibles.sort((a, b) => {
                let asc = currentSort.dir === "asc";
                if (a.statut === "Disponible" && b.statut !== "Disponible")
                    return asc ? -1 : 1;
                else if (a.statut !== "Disponible" && b.statut === "Disponible")
                    return asc ? 1 : -1;
                return 0;
            });
    };

    return <Grid data={processData()}
        sort={sort} sortable={{ allowUnsort: false, mode: 'single' }} onSortChange={handleSortChange}
        className="k-flex-grow k-h-full k-overflow-auto">
        <GridColumn field="nom" title="Employé" />
        <GridColumn field="statut" title="Statut" cell={CustomCell} />
    </Grid>
}